export default __webpack_public_path__ + "static/assets/25db5e5bcc09e8b973e5e8775139a188.jpg";